export default __webpack_public_path__ + "static/media/info.b2dafb9c.svg";